// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5cc79a95","455":"5f639f55","977":"0b8d96e3"}[chunkId] + ".chunk.js";
};